import "./sass/style.scss"
// import "./js/customizer"
import "./js/navigation"
import "./js/skip-link-focus-fix"
import 'bootstrap'
import $ from 'jquery';
import Masonry from 'masonry-layout';
let imagesLoaded = require('imagesloaded');
const images = require.context('./images', true, /\.(jpe?g|png|gif|svg)$/);

imagesLoaded.makeJQueryPlugin( $ );

function parse_query_string(query) {
    var vars = query.split("&");
    var query_string = {};
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1]);
        // If first entry with this name
        if (typeof query_string[key] === "undefined") {
            query_string[key] = decodeURIComponent(value);
            // If second entry with this name
        } else if (typeof query_string[key] === "string") {
            var arr = [query_string[key], decodeURIComponent(value)];
            query_string[key] = arr;
            // If third or later entry with this name
        } else {
            query_string[key].push(decodeURIComponent(value));
        }
    }
    return query_string;
}

$(document).ready(function(){
    if($('.grid').length){
        $('.grid').imagesLoaded(function () {
            let msnry = new Masonry( '.grid', {
                itemSelector: '.grid-item',
                percentPosition: true,
                columnWidth: '.col-md-4',
            });
        });
    }

    // Preselect the package type on the booking form
    setSelect('package-type');
    setSelect('hunting-package');
    setSelect('fishing-package');
    setSelect('number-of-guests');

    function setSelect(selectName){
        var urlParams = parse_query_string(window.location.search.substring(1));
        if(typeof urlParams[selectName] !== "undefined"){
            $("select[name='"+selectName+"']").val(urlParams[selectName]);
        }
    }

    $('.slick-carousel').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        arrows: true,
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

});

